define.alias("shared/helpers/format-date", "calendar/helpers/format-date");